/**
 * 高德原生组件
 * zxw
 * 2024-09-04
 */
import * as ReactDOM from 'react-dom/client';
import { useEffect, useState } from 'react';
import $ from 'jquery';
import AMapLoader from '@amap/amap-jsapi-loader';
import CNF from '../../incs/Config';
import { UjoinParams, AddRequestHeaders, winWidth, 
    winHeight, WGS84ToGCJ02, CopyToClipboard} from '../../incs/FunHelper';
import { Button, Input, message } from 'antd';
import {
    SearchOutlined,
    StockOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined,
} from '@ant-design/icons';

import WWA from '../../images/walkway-aim.svg';
import TFR from '../../images/traffic-right-aim.svg';
import POLICECAR1 from '../../images/police-car.svg';
import POLICECAR2 from '../../images/police-car.gif';

//  自定义icon
import TRIcon from '../icons/TRIcon';
import WalkwayIcon from '../icons/WalkwayIcon';

import MainImagePreview from '../../components/intersections/MainImagePreview';
import WalkwayImagePreview from '../../components/intersections/WalkwayImagePreview';
import { get } from '@ant-design/plots/es/core/utils';

var rootImage = null;
var intervalId = null;
var isShowLnglat = 0;

function GetPointsBetweenLatLong(lonlat1,lonlat2,numPoints) {
    const lon1 = lonlat1[0];
    const lat1 = lonlat1[1];
    const lon2 = lonlat2[0];
    const lat2 = lonlat2[1];
    const points = [];
    const dLat = (lat2 - lat1) / (numPoints + 1);
    const dLon = (lon2 - lon1) / (numPoints + 1);
    
    for (let i = 1; i <= numPoints; i++) {
        const lat = lat1 + i * dLat;
        const lon = lon1 + i * dLon;
        points.push([lon,lat]);
    }
    return points;
}

const AMapContainer = () => {
    const [aMap, setAMap] = useState(null);
    const [map, setMap] = useState(null);
    const [intersectionLL, setIntersectionLL] = useState(null);         //  路口图层
    const [showIntersectionLL, setShowIntersectionLL] = useState(1);    //  路口图层是否显示
    const [walkwayLL, setWalkwayLL] = useState(null);                   //  行人过街图层
    const [showWalkwayLL, setShowWalkwayLL] = useState(1);              //  行人过街图层是否显示
    const [traffic, setTraffic] = useState(null);
    const [isShowTraffic, setIsShowTraffic] = useState(1);  //  是否显示实时路况
    const [searchOpen, setSearchOpen] = useState(0);
    const [intersectionName, setIntersectionName] = useState('');
    const [intersectionFullname, setIntersectionFullname] = useState('');
    const [lnglat, setLnglat] = useState('');               //  经纬度
    const [isFullScreen, setIsFullScreen]  = useState(0);   //  是否全屏

    /**
     * 鼠标移入路口信息显示弹框
     * @param {*} item 
     * @returns 
     */
    const intersectionMarkerContent = (item) => {
        let isNetwork = item.host_machine_is_networking?
        '<span class="span-green">是</span>':'<span class="span-red">否</span>';
        return '<div class="amap-info-window">'
            + '<h4>路口信息</h4>'
            + '<p>路口名称：' + item.name + '</p>'
            + '<p>路口编码：' + item.number + '</p>'
            + '<p>路口类型：' + item.structure + '</p>'
            + '<p>放行方式：' + item.type + '</p>'
            + '<p>主机品牌：' + item.host_machine_model + '</p>'
            + '<p>网络厂商：' + item.operator + '</p>'
            + '<p>是否联网：' + isNetwork + '</p>'
            + '<p>建设年份：' + item.create_year + '年</p>'
            + '<div class="amap-info-sharp"></div>'
        + '</div>'
    }

    /**
     * 鼠标移入行人过街显示弹框
     * @param {*} item 
     * @returns 
     */
    const walkwayMarkerContent = (item) => {
        return '<div class="amap-info-window">'
            + '<h4>行人过街</h4>'
            + '<p>名称：' + item.name + '</p>'
            + '<p>编码：' + item.number + '</p>'
            + '<p>主机：' + item.host_machine + '</p>'
            + '<p>主机型号：' + item.host_machine_model + '</p>'
            + '<p>建设年份：' + item.create_year + '年</p>'
            + '<div class="amap-info-walkway"></div>'
        + '</div>'
    }

    /**
     * 获取区域坐标
     * @param {*} url   geojson格式数据
     * @param {*} map   map实例对象
     * @param {*} AMap  AMap实例对象
     */
    const getGEOJson = (url,map,AMap) => {
        fetch(url)
        .then((response) => response.json())
        .then((data) => {
            let path = data.features[0].geometry.coordinates[0][0];
            //  创建多边形 Polygon 实例
            var polygon = new AMap.Polygon({
                path: path,             //  路径
                fillColor: '#045263',   //  多边形填充颜色
                strokeWeight: 2,        //  线条宽度，默认为 2
                strokeColor: '#04C0C2', //  线条颜色
                cursor: 'pointer',
                // strokeOpacity: 0.9,
            });
            //  鼠标移入事件
            polygon.on('mouseover', () => {
                polygon.setOptions({//  修改多边形属性的方法
                    strokeColor: '#3284F7',
                });
            });
            //  鼠标移出事件
            polygon.on('mouseout', () => {
                polygon.setOptions({//  修改多边形属性的方法
                    strokeColor: '#04C0C2',
                });
            });
            //  鼠标点击事件
            polygon.on('click', (e) => {
                polygon.setOptions({    //  修改多边形属性的方法
                    strokeColor: '#FF904D',
                });
                //  复制经纬度
                if(isShowLnglat){
                    if(e.lnglat){
                        let lnglat = e.lnglat.lng + ',' + e.lnglat.lat
                        CopyToClipboard(lnglat);
                    }
                }
            });
            //  鼠标移动事件
            polygon.on('mousemove',function(e){
                //  获取鼠标选择点经纬度
                if(e.lnglat){
                    let lnglat = e.lnglat.lng + ',' + e.lnglat.lat
                    setLnglat(lnglat);
                }
            });
            //  多边形 Polygon对象添加到 Map
            map.add(polygon);
            //  将覆盖物调整到合适视野
            map.setFitView([polygon]);
    });
    }

    /**
     * 获取红绿灯路口，并添加文本图层
     * @param {*} map   map实例对象
     * @param {*} AMap  AMap实例对象
     */
    const getIntersections = (map, AMap) => {
        //  获取红绿灯标点
        const intersectionLL = new AMap.LabelsLayer({
            zooms: [2, 20],
            zIndex: 1000,
            collision: true,        //  该层内标注是否避让
            allowCollision: true,   //  不同标注层之间是否避让  
        });
        const icon = {
            type: 'svg',
            size: [16, 37],
            image: TFR,
            anchor: 'center',
        };
        var params = {
            'name':intersectionName,
            'full_name':intersectionFullname,
            'page_size': 65535,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}intersections${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    let initData = data.dat;
                    if(initData.length > 0){
                        let labelMarkerArr = [];
                        // 普通点
                        var normalMarker = new AMap.Marker({
                            anchor: 'bottom-center',
                            offset: [0, -30],
                        });
                        for(let i=0; i<initData.length; i++){
                            let item = initData[i];
                            if(item.longitude && item.latitude){
                                let position = [];
                                position.push(item.longitude);
                                position.push(item.latitude);
                                let LM = {
                                    position: position,
                                    zIndex: 16,
                                    rank: 1,        // 避让优先级
                                    icon: icon,
                                }
                                const labelMarker = new AMap.LabelMarker(LM);
                                labelMarker.on('mouseover',function(e){
                                    //  鼠标移入
                                    var position = e.data.data && e.data.data.position;
                                    if(position){
                                        normalMarker.setContent(intersectionMarkerContent(item));
                                        normalMarker.setPosition(position);
                                        map.add(normalMarker);
                                    }
                                });
                                labelMarker.on('mouseout',function(){
                                    //  鼠标移出
                                    map.remove(normalMarker);
                                });
                                labelMarker.on('click', function(){
                                    //  鼠标点击
                                    const params = {
                                        'intersection_ulid': item.key,
                                        'is_main': 1,
                                        'page_size': 1,
                                        'current_index': 1
                                    };
                                    $.ajax({
                                        url: `${CNF.api}intersection/images${UjoinParams(params)}`,
                                        headers: AddRequestHeaders(),
                                        type: 'GET',success:function(data){
                                            if(data.res === 0){
                                                if(data.dat.length > 0){
                                                    if(!rootImage){
                                                        rootImage = ReactDOM.createRoot(document.getElementById('show-image-id'));
                                                    }
                                                    rootImage.render(
                                                    <MainImagePreview
                                                        open={true}
                                                        record={data.dat[0]}
                                                    />);
                                                }
                                            }
                                        }
                                    });
                                })
                                labelMarkerArr.push(labelMarker);
                            }
                            
                        }
                        intersectionLL.add(labelMarkerArr);
                    }else{
                        //
                    }
                }
            }
        });
        map.add(intersectionLL);
        setIntersectionLL(intersectionLL);
    }

    /**
     * 获取行人过街，并添加文本图层
     * @param {*} map   map实例对象
     * @param {*} AMap  AMap实例对象
     */
    const getWalkways = (map, AMap) => {
        //  获取红绿灯标点
        const walkwayLL = new AMap.LabelsLayer({
            zooms: [2, 20],
            zIndex: 1001,
            collision: true,        //  该层内标注是否避让
            allowCollision: true,   //  不同标注层之间是否避让  
        });
        const icon = {
            type: 'svg',
            size: [24, 24],
            image: WWA,
            anchor: 'center',
        };
        var params = {
            // 'name':intersectionName,
            // 'full_name':intersectionFullname,
            'page_size': 65535,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}walkways${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    let initData = data.dat;
                    if(initData.length > 0){
                        let labelMarkerArr = [];
                        // 普通点
                        var normalMarker = new AMap.Marker({
                            anchor: 'bottom-center',
                            offset: [0, -30],
                        });
                        for(let i=0; i<initData.length; i++){
                            let item = initData[i];
                            if(item.longitude && item.latitude){
                                let position = [];
                                position.push(item.longitude);
                                position.push(item.latitude);
                                let LM = {
                                    position: position,
                                    zIndex: 16,
                                    rank: 1,        // 避让优先级
                                    icon: icon,
                                }
                                const labelMarker = new AMap.LabelMarker(LM);
                                labelMarker.on('mouseover',function(e){
                                    //  鼠标移入
                                    var position = e.data.data && e.data.data.position;
                                    if(position){
                                        normalMarker.setContent(walkwayMarkerContent(item));
                                        normalMarker.setPosition(position);
                                        map.add(normalMarker);
                                    }
                                });
                                labelMarker.on('mouseout',function(){
                                    //  鼠标移出
                                    map.remove(normalMarker);
                                });
                                labelMarker.on('click', function(){
                                    //  鼠标点击
                                    const params = {
                                        'walkway_ulid': item.key,
                                        'page_size': 1,
                                        'current_index': 1
                                    };
                                    $.ajax({
                                        url: `${CNF.api}walkway/images${UjoinParams(params)}`,
                                        headers: AddRequestHeaders(),
                                        type: 'GET',success:function(data){
                                            if(data.res === 0){
                                                if(data.dat.length > 0){
                                                    if(!rootImage){
                                                        rootImage = ReactDOM.createRoot(document.getElementById('show-image-id'));
                                                    }
                                                    rootImage.render(
                                                    <WalkwayImagePreview
                                                        open={true}
                                                        record={data.dat[0]}
                                                    />);
                                                }
                                            }
                                        }
                                    });
                                })
                                labelMarkerArr.push(labelMarker);
                            }
                        }
                        walkwayLL.add(labelMarkerArr);
                    }else{
                        //
                    }
                }
            }
        });
        map.add(walkwayLL);
        setWalkwayLL(walkwayLL);
    }

    /**
     * 实时获取路线位置
     * @param {*} map 
     * @param {*} AMap 
     * @param {*} lp            //  路线途经位置
     * @param {*} lineAcode     //  路线授权编码
     * @param {*} useSN         //  路线使用序号
     * @param {*} lineCount     //  路线可用数量
     */
    const aim = (map, AMap, lp, lineAcode, useSN, lineCount, routeLngLat) => {
        //  去除重复的点
        for(let i=0; i<routeLngLat.length; i++){
            for(let j=0; j<routeLngLat.length; j++){
                if(routeLngLat[i].toString() === routeLngLat[j].toString() && i !== j){
                    routeLngLat.splice(j, 1);
                }
            }
        }
        var expRouteLngLat = [];
        for(let i=0; i<routeLngLat.length - 1; i++){
            expRouteLngLat.push(routeLngLat[i]);
            let midLngLats = GetPointsBetweenLatLong(routeLngLat[i], routeLngLat[i+1],2);
            expRouteLngLat.push(midLngLats[0]);
            expRouteLngLat.push(midLngLats[1]);
        }
        expRouteLngLat.push(routeLngLat[routeLngLat.length - 1]);
        var icon1 = new AMap.Icon({
            type: 'svg',
            size: [39,78],
            image: POLICECAR1,
            anchor: 'center',
        });

        var icon2 = new AMap.Icon({
            type: 'gif',
            size: [39,78],
            image: POLICECAR2,
            anchor: 'center',
        });

        let marker = lp;
        //  标注警车
        marker = new AMap.Marker({
            map: map,
            position: lp[0],
            icon: icon1,
            offset: new AMap.Pixel(-12, -39),
        });

        //  移动前轨起始点
        var passedPath = [lp[0]];

        //  移动后轨迹样式
        var passedPolyline = new AMap.Polyline({
            map: map,
            strokeColor: "#4A83FD",     //  线颜色
            strokeOpacity: 1,           //  线透明度
            strokeWeight: 8,            //  线宽
            strokeStyle: 'solid',       //  线样式
            lineJoin: "round",          //  折线拐点连接处样式
            bubble: true,
            // isOutline: true,
            outlineColor: '#365CB3',
            borderWeight: 2,
        });

        marker.on('moving', function (e) {
            passedPolyline.setPath(passedPath);
            //  只有1条线路时，中心点随轨迹移动
            if(lineCount===1){
                map.setCenter(e.target.getPosition(),true);
            }
        });

        marker.on('click', function(){
            if(intervalId){
                clearInterval(intervalId);
                intervalId = null;
                marker.setIcon(icon1);
                message.warning('路线已关闭！', 1.5);
                return;
            }
            passedPath = [lp[0]];   //  运动轨迹回归到出发点
            var sSN = 0;            //  坐标点起始序号，默认起始点
            var eSN = 0;            //  坐标点结束序号，默认起始点
            var sn  = 0;            //  请求序号
            intervalId = setInterval(()=>{
                //  获取路径目标点
                var params = {
                    'sn': sn,
                    'use_sn': useSN, 
                    'line_acode':lineAcode,
                    'page_size': 65565,
                    'current_index': 1
                };
                $.ajax({
                    url: `${CNF.api}line/aims${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    type: 'GET',success:function(data){
                        if(data.res === 0 && data.dat.length > 0){
                            let dLength = data.dat.length;
                            let latestItem = data.dat[dLength-1];
                            if(latestItem.sn > sn){
                                //  最新请求序列号
                                sn = latestItem.sn; 
                            }
                            if(dLength > 15){
                                //  判断为触发重新启动
                                for(let i=0; i<dLength; i=i+3){
                                    let item = i+3>=dLength?data.dat[dLength-1]:data.dat[i];
                                    let lnglat = [item.longitude,item.latitude];
                                    //  坐标系类型转换
                                    if(item.cs_type === 'WGS84'){ //  gps
                                        lnglat = WGS84ToGCJ02(item.longitude,item.latitude);
                                    };
                                    //  两点间距离，默认10000
                                    let disbtp = 10000;                 
                                    //  计算两点间的距离，获取5个点中最近的点
                                    //  以此逻辑来纠偏轨迹
                                    let loopLength =sSN+5>expRouteLngLat.length?expRouteLngLat.length:sSN+5;
                                    for(let i=sSN; i<loopLength; i++){
                                        let distance = AMap.GeometryUtil.distance(lnglat, expRouteLngLat[i]);
                                        if(distance < disbtp){
                                            disbtp = distance;
                                            eSN = i;
                                        }
                                    }
                                    sSN = eSN;
                                }
                                for(let j=1; j<=eSN; j++){
                                    //  添加轨迹坐标
                                    let aim = expRouteLngLat[j];
                                    passedPath.push(aim);
                                }
                                //  移动至最新的点
                                let latestAim = expRouteLngLat[expRouteLngLat.length - 1];
                                marker.setPosition(latestAim);
                                marker.moveTo(latestAim, {
                                    duration: 0,      
                                    autoRotation: true,
                                });
                            }else{
                                //  取最新一个坐标
                                for(let i=dLength-1; i<dLength; i++){
                                    let item = data.dat[i];
                                    let lnglat = [item.longitude,item.latitude];
                                    //  坐标系类型转换
                                    if(item.cs_type === 'WGS84'){ //  gps
                                        lnglat = WGS84ToGCJ02(item.longitude,item.latitude);
                                    };
                                    //  两点间距离，默认10000
                                    let disbtp = 10000;                 
                                    //  计算两点间的距离，获取5个点中最近的点
                                    //  以此逻辑来纠偏轨迹
                                    let loopLength =sSN+5>expRouteLngLat.length?expRouteLngLat.length:sSN+5;
                                    for(let i=sSN; i<loopLength; i++){
                                        let distance = AMap.GeometryUtil.distance(lnglat, expRouteLngLat[i]);
                                        if(distance < disbtp){
                                            disbtp = distance;
                                            eSN = i;
                                        }
                                    }
                                    let cnt = eSN - sSN;
                                    if (cnt > 0){
                                        let dur = parseInt(3180/cnt);
                                        for(let i=1; i<=cnt; i++){
                                            //  最新坐标
                                            let aim = expRouteLngLat[sSN+i];
                                            if(i === 1){
                                                marker.moveTo(aim, {
                                                    duration: dur,      
                                                    autoRotation: true,
                                                });
                                                setTimeout(() => {
                                                    passedPath.push(aim);
                                                    marker.setPosition(aim);
                                                }, dur>1000?1000:dur);
                                            }else if(i > 1){
                                                setTimeout(() => {
                                                    marker.moveTo(aim, {
                                                        duration: dur,      // 移动间距时长，可根据实际采集时间间隔设置
                                                        autoRotation: true, // JSAPI2.0 是否延道路自动设置角度在 moveAlong 里设置
                                                    });
                                                }, dur);
                                                setTimeout(() => {
                                                    passedPath.push(aim);
                                                    marker.setPosition(aim);
                                                }, dur);
                                            }
                                        }
                                        sSN = eSN;
                                    }
                                }
                            }
                        }
                    }
                });
            }, 3000);
            marker.setIcon(icon2);
            message.success('路线已启动！', 1.5);
        });
    }

    /**
     * 根据路线途经的点绘制路线
     * @param {*} map 
     * @param {*} AMap 
     */
    const getLines = (map, AMap) => {
        var params = {
            'status': CNF.status[0].value,
            'page_size': CNF.pageSize,
            'current_index': 1
        };

        //  获取线路信息
        $.ajax({
            url: `${CNF.api}lines${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        //  绘制线路
                        for(let i=0; i<data.dat.length; i++){
                            let item = data.dat[i];
                            let lp = JSON.parse(item.path);
                            //  构造路线导航类
                            var driving = new AMap.Driving({
                                map: map,
                                // isOutline: false,
                                // panel: 'panel',
                                autoFitView: true,
                                showTraffic: true,
                                // hideMarkers: false,
                            });
                            let ws = [];    //  途经点
                            for(let j=1;j<lp.length-1;j++){
                                let lng = lp[j][0];
                                let lat = lp[j][1];
                                
                                ws.push(new AMap.LngLat(lng, lat));
                            }
                            let start = lp[0];
                            let end = lp[lp.length - 1];
                            // 根据起终点经纬度规划驾车导航路线
                            driving.search(new AMap.LngLat(start[0], start[1]), new AMap.LngLat(end[0], end[1]),{
                                waypoints: ws
                            },function (status, result) {
                                // result 即是对应的驾车导航信息，相关数据结构文档请参考  
                                //  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
                                if (status === 'complete') {
                                    let routeLngLat = [];   //  轨迹途经的经纬度集合
                                    let routeLines = result.routes[0].steps;
                                    for(let k=0; k<routeLines.length; k++){
                                        for(let l=0; l<routeLines[k].tmcs.length; l++){
                                            for(let m=0; m<routeLines[k].tmcs[l].path.length; m++){
                                                routeLngLat.push([routeLines[k].tmcs[l].path[m].lng,routeLines[k].tmcs[l].path[m].lat]);
                                            }
                                        }
                                    }
                                    //  实时定位
                                    aim(map, AMap, lp, item.acode, item.use_sn, data.dat.length, routeLngLat);
                                    console.log('驾车路线绘制完成');
                                    // map.setCenter([116.442581,39.882498])
                                } else {
                                    console.log('获取驾车数据失败：' + result);
                                }
                            });
                        }
                    }
                }
            }
        })
    }

    useEffect(()=>{
        window._AMapSecurityConfig = {
            securityJsCode: 'ceea76ab9503e286229776114f3a1cbd',
        };

        var params = {
            'page_size': 1,
            'current_index': 1
        };
        //  获取组织区域信息
        $.ajax({
            url: `${CNF.api}setting/areas${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        let item = data.dat[0];
                        let center = [];
                        //  是否开启定位
                        isShowLnglat = parseInt(item.open_position);
                        //  设置中心点经纬度
                        center.push(item.longitude);
                        center.push(item.latitude);
                        AMapLoader.load({
                            key:'e43074060ab1913e75577155b646d10e',       //   申请好的Web端开发者Key，首次调用 load 时必填
                            version: '2.0',                               //   指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                            plugins: [
                                // 'AMap.Scale','AMap.ToolBar',
                                // 'AMap.HawkEye',
                                // 'AMap.MapType',
                                'AMap.ControlBar',
                                'AMap.Driving',
                                'AMap.MoveAnimation',
                                'AMap.PolylineEditor',
                                'AMap.GraspRoad',
                                'AMap.TileLayer',
                            ],                                          
                        }).then((AMap)=>{
                            setAMap(AMap);
                            let map = new AMap.Map('a-map-container',{    //   设置地图容器id
                                viewMode: '3D',                           //   是否为3D地图模式
                                // zooms: [2,20],                                 //   初始化地图级别
                                center: center,                           //   初始化地图中心点位置
                                mapStyle: 'amap://styles/blue',
                                rotateEnable:true,
                                pitchEnable:true,
                                resizeEnable: true,
                                zoom: 14,
                                layers: [
                                    // 卫星
                                    // new AMap.TileLayer.Satellite(),
                                    // 路网
                                    // new AMap.TileLayer.RoadNet()
                                ], 
                                // pitch: 50,
                                // rotation: 45,
                            });
                            // let toolBar = new AMap.ToolBar();             //   工具条，控制地图的缩放、平移等    
                            // let scale = new AMap.Scale();                 //   比例尺，显示当前地图中心的比例尺
                            // let mapType = new AMap.MapType();             //   图层切换，通过该插件可以进行地图切换
                            // let controlBar = new AMap.ControlBar({
                            //     position:{
                            //         right:'10px',
                            //         top:'10px'
                            //     }
                            // });

                            //  鼠标移动事件
                            map.on('mousemove',function(e){
                                //  获取鼠标选择点经纬度
                                if(e.lnglat){
                                    let lnglat = e.lnglat.lng + ',' + e.lnglat.lat
                                    setLnglat(lnglat);
                                }
                            });

                            map.on('click',function(e){
                                //  获取鼠标选择点经纬度
                                if(isShowLnglat){
                                    if(e.lnglat){
                                        let lnglat = e.lnglat.lng + ',' + e.lnglat.lat
                                        CopyToClipboard(lnglat);
                                    }
                                }
                            });

                            map.on('complete', function(){
                                //   添加插件
                                // map.addControl(toolBar);                      
                                // map.addControl(scale);
                                // map.addControl(mapType);
                                // map.addControl(controlBar);

                                //  创建实时交通图层
                                var traffic = new AMap.TileLayer.Traffic({
                                    autoRefresh: true,  //  是否自动刷新
                                    interval: 180,      //  刷新间隔，默认180s
                                    visible: true,
                                    zooms: [2,30],
                                });
                                //  通过 add 方法将图层添加到地图
                                map.add(traffic);
                                setTraffic(traffic);
                                traffic.on('complete', function(e) {
                                    console.log(e);
                                });
                                //  获取区域边界坐标数据
                                let url = 'https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/geojson/' + item.adcode + '.json';

                                getGEOJson(url,map,AMap);
                                getIntersections(map,AMap); 
                                getWalkways(map,AMap); 
                                getLines(map,AMap);
                                setMap(map);    
                            });
                        }).catch(e=>{
                            console.log(e);
                        })
                    }
                }
            }
        })
    },[]);

    useEffect(()=>{
        if(map && aMap){
            //  移除现有图层
            map.remove(intersectionLL);
            getIntersections(map,aMap);
        }
    },[intersectionFullname,intersectionName]);

    return <>
        <div style={{ position: isFullScreen?'fixed':'relative',
            height: isFullScreen?winHeight:'100%',
            width: isFullScreen?winWidth:'100%',
            top: 0,
            left: 0,
            zIndex: 999,
        }}>
            <div id='a-map-container' style={{ height: '100%',width: '100%' }} ></div>
            <div style={{ position: 'absolute', top: 0, left: 0, paddingTop: 8,paddingLeft: 8,}}>
                <Button style={{ 
                    background:'#020F3A',
                    border:'1px solid #020F3A',
                    opacity: 1, 
                    borderRadius: 3, 
                    color: '#04C0C2', 
                    fontSize: 20, 
                    fontWeight: 400,
                }} onClick={() => {setSearchOpen(searchOpen===2?0:searchOpen+1);}} icon={<SearchOutlined />} /> 
                <div style={{ float: 'right',marginLeft: 5, display: searchOpen ? 'block' : 'none' }}>
                    {
                        searchOpen&&searchOpen===1?<Input style={{ 
                            height: 30, 
                            border: 0, 
                            borderRadius: 3,
                            opacity: 0.5,
                            fontSize: 13,
                            // color: '#04C0C2', 
                        }} 
                            placeholder='路口名称'
                            value={intersectionName}
                            onChange={(e) => {setIntersectionName(e.target.value);}}
                        />:''
                    }
                    {
                        searchOpen&&searchOpen===2?<Input style={{ 
                            height: 30, 
                            border: 0, 
                            borderRadius: 3,
                            opacity: 0.5,
                            fontSize: 13,
                            // color: '#04C0C2', 
                        }} 
                            placeholder='路口全称'
                            value={intersectionFullname}
                            onChange={(e) => {setIntersectionFullname(e.target.value);}}
                        />:''
                    }
                </div>
                <div>
                    <Button style={{ 
                        background:'#020F3A',
                        border:'1px solid #020F3A',
                        opacity: 1, 
                        borderRadius: 3, 
                        color: '#04C0C2', 
                        fontSize: 30, 
                        fontWeight: 400,
                        marginTop: 8,
                    }} onClick={() => {
                        if(showIntersectionLL){
                            map.remove(intersectionLL);    //  移除图层
                        }else{
                            map.add(intersectionLL);       //  添加图层
                        }
                        setShowIntersectionLL(showIntersectionLL?0:1);
                        
                    }} icon={<TRIcon />} /> 
                </div>
                <div>
                    <Button style={{ 
                        background:'#020F3A',
                        border:'1px solid #020F3A',
                        opacity: 1, 
                        borderRadius: 3, 
                        color: '#04C0C2', 
                        fontSize: 20, 
                        fontWeight: 400,
                        marginTop: 8,
                    }} onClick={() => {
                        if(showWalkwayLL){
                            map.remove(walkwayLL);    //  移除图层
                        }else{
                            map.add(walkwayLL);       //  添加图层
                        }
                        setShowWalkwayLL(showWalkwayLL?0:1);
                        
                    }} icon={<WalkwayIcon style={{ color: '#04C0C2'}} />} /> 
                </div>
                <div>
                    <Button style={{ 
                        background:'#020F3A',
                        border:'1px solid #020F3A',
                        opacity: 1, 
                        borderRadius: 3, 
                        color: '#04C0C2', 
                        fontSize: 20, 
                        fontWeight: 400,
                        marginTop: 8,
                    }} onClick={() => {
                        if(isShowTraffic && traffic){
                            traffic.hide();    //  隐藏实时路况
                        }else if(traffic){
                            traffic.show()     //  显示实时路况
                        }
                        setIsShowTraffic(isShowTraffic?0:1);
                        
                    }} icon={<StockOutlined />} /> 
                </div>
                <div>
                    <Button style={{ 
                        background:'#020F3A',
                        border:'1px solid #020F3A',
                        opacity: 1, 
                        borderRadius: 3, 
                        color: '#04C0C2', 
                        fontSize: 20, 
                        fontWeight: 400,
                        marginTop: 8,
                    }} onClick={() => {
                        setIsFullScreen(isFullScreen?0:1);
                        
                    }} icon={isFullScreen?<FullscreenExitOutlined />:<FullscreenOutlined />} /> 
                </div>
            </div>
            <div style={{ position: 'absolute', bottom: 20, left: 0, paddingTop: 8,paddingLeft: 8,}}>
                {
                    isShowLnglat&&lnglat?<div style={{ fontSize: 12,padding: '2px 5px', background:'#fff',borderRadius: 3}}>{lnglat}</div>:''
                }
            </div>
        </div>
        <div id='show-image-id'></div>
    </>
}

export default AMapContainer;